import { END_POINTS } from "../constants/urls";
import emptySplitApi from "../utils/rtk";

type CommonResponse = {
  status: number;
  data?: any;
  message: string;
};

export const dashboardApi = emptySplitApi.injectEndpoints({
  endpoints: (builder) => ({
    getDashboard: builder.query<CommonResponse, {}>({
      query: () => ({
        url: `${END_POINTS.getDashboard}`,
        method: "GET",
      }),
    }),

    getNewSignups: builder.query<CommonResponse, {}>({
      query: () => ({
        url: `${END_POINTS.newSignups}`,
        method: "GET",
      }),
    }),

    getTodayBookings: builder.query<CommonResponse, {}>({
      query: () => ({
        url: `${END_POINTS.getTodayBookings}`,
        method: "GET",
      }),
    }),

    getTopMembers: builder.query<CommonResponse, {}>({
      query: () => ({
        url: `${END_POINTS.topMembers}`,
        method: "GET",
      }),
    }),

    getActiveMembers: builder.query<CommonResponse, {}>({
      query: () => ({
        url: `${END_POINTS.activeMembers}`,
        method: "GET",
      }),
    }),

    getExpiringTrials: builder.query<CommonResponse, {}>({
      query: () => ({
        url: `${END_POINTS.expiringTrials}`,
        method: "GET",
      }),
    }),

    getUpcomingRenewals: builder.query<CommonResponse, {}>({
      query: () => ({
        url: `${END_POINTS.upcomingRenewals}`,
        method: "GET",
      }),
    }),

      getMemberEngagement: builder.query<CommonResponse, {filters:string}>({
        query: ({filters}) => ({
          url: `${END_POINTS.memberEngagement}?filter=${filters}`,
          method: "GET",
        }),
      }),

      getPopularOffers: builder.query<CommonResponse, {filters:string}>({
        query: ({filters}) => ({
          url: `${END_POINTS.popularOffers}?filters=${filters}`,
          method: "GET",
        }),
      }),


  }),
});

export const {
  useLazyGetDashboardQuery,
  useLazyGetNewSignupsQuery,
  useLazyGetTodayBookingsQuery,
  useLazyGetTopMembersQuery,
  useLazyGetActiveMembersQuery,
  useLazyGetExpiringTrialsQuery,
  useLazyGetUpcomingRenewalsQuery,
  useLazyGetMemberEngagementQuery,
  useLazyGetPopularOffersQuery,
} = dashboardApi;
